// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__12sTJ","grid":"search_grid__3z5f8","searchWrapper":"search_searchWrapper__3QuSX page_searchWrapper__1RdJg"};